import { Controller } from "@hotwired/stimulus"

// While the textarea holds an unsent note the form opts out of morph
// refreshes — idiomorph syncs a textarea's value back to the server-rendered
// (empty) one, so a teammate's update landing mid-typing would wipe it. Once
// the server accepts a note we clear and refocus the box to keep the writing
// flow going. A failed submission keeps the text for another go.
export default class extends Controller {
  static targets = ["input"]

  connect() {
    this.guard = (event) => {
      if (this.inputTarget.value !== "") event.preventDefault()
    }
    this.element.addEventListener("turbo:before-morph-element", this.guard)
  }

  disconnect() {
    this.element.removeEventListener("turbo:before-morph-element", this.guard)
  }

  submitted(event) {
    if (!event.detail.success) return

    this.element.reset()
    this.inputTarget.focus()
  }
}
